export const LOGIN = "/login";

export const HOME = "/";

export const EXPLORE = "/explore";

export const CLUB_LISTING = "/clubs";

export const CLUB_DETAIL = "/club/";

export const BESPOKE_DETAIL = "/bespoke/";

export const EVENT_DETAIL = "/event/";

export const BOOKING = "/bookings";

export const ACTIVATES = "/activate";

export const FORGOT = "/forgot";

export const RESETPASSWORD = "/auth/password";

export const CONNECTIONS = "/connections";
export const NETWORK = "/network";

export const PROFILE_SETTINGS = "/profile-settings";

export const INTEREST = "/interest";

export const MY_CARDS = "/my-cards";

export const SETTINGS = "/settings";
export const REFERRAL = "/referral";
export const INVITE_SPOUSE = "/invite-spouse";

export const CHANGE_PASSWORD = "/change-password";

export const SUPPORT = "/support";

export const TERMS = "/terms-and-conditions";

export const PRIVACY_POLICY = "/privacy-policy";

export const EULA = "/eula";

export const CANCELLATION_POLICY = "/cancellation-policy";

export const SUBSCRIPTION = "/subscription";

export const LANGUAGE = "/language";

export const VERFIY_EMAIL = "/verfiy-email";

export const EVENT_LIST = "/event-list";

export const FAVOURITES = "/favourites";

export const CLUBS_CONNECTIONS = "/clubs-connections";

export const SEARCH_CLUBS_CONNECTIONS = "/search-clubs-connections";

export const CLUB_NETWORK = "/club-network/:id";

export const RECIPROCAL_CLUBS = "/club-network/reciprocal-clubs";

export const GLOBAL_CLUBS = "/club-network/global-clubs";

export const SPOTLIGHT_CLUBS = "/club-network/spotlight-clubs";

export const NOTIFICATION = "/notifications";

export const LOCATION_EXPLORE = "/location-explore";

export const ACTIVITES_DETAILS = "/activities/";
export const FACILITY_DETAILS = "/facility/";

export const SOLTARIRE_CLUBS = "/club-network/solitarie-clubs";

export const TERMS_AND_CONDITION = "/terms-and-condition";

export const CLUB_RULES = "/club-rules/";

export const PRIVACY_POLICYs = "/privacy--policy";
export const USER_JOURNEY = "/user-journey";

export const CHECKOUT_SUCCESS = "/success";

export const CHECKOUT_ERROR = "/error";
export const WELCOME = "/welcome";

export const UNSUBSCRIBE_USER = "/unsubscribe-email";

export const SSO = "/sso";
export const EULA_OTHER='/end-user'
